/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const PrintSolidV6 = (props) => (
  <Icon {...props} name="Print Solid V6">
    <path d="M14 6H2a2 2 0 0 0-2 2v3a1 1 0 0 0 1 1h1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3h1a1 1 0 0 0 1-1V8c0-1.103-.897-2-2-2zm-2 8H4v-3h8v3zm1.5-4.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zM4 2h7.172l.828.828V5h2V2.414a1 1 0 0 0-.293-.707L12.293.293A.999.999 0 0 0 11.587 0H3a1 1 0 0 0-1 1v4h2V2z" />
  </Icon>
);

export default PrintSolidV6;
